export * as groups from '@wix/auto_sdk_groups_groups/meta';
export * as members from '@wix/auto_sdk_groups_members/meta';
export * as groupRequests from '@wix/auto_sdk_groups_group-requests/meta';
export * as roles from '@wix/auto_sdk_groups_roles/meta';
export * as rules from '@wix/auto_sdk_groups_rules/meta';
export * as joinGroupRequests from '@wix/auto_sdk_groups_join-group-requests/meta';
export * as membershipQuestions from '@wix/auto_sdk_groups_membership-questions/meta';
